import { render, staticRenderFns } from "./BaseBlockIndex.vue?vue&type=template&id=067294ca&scoped=true&"
import script from "./BaseBlockIndex.vue?vue&type=script&lang=js&"
export * from "./BaseBlockIndex.vue?vue&type=script&lang=js&"
import style0 from "./BaseBlockIndex.vue?vue&type=style&index=0&id=067294ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067294ca",
  null
  
)

export default component.exports